import { gql } from '@apollo/client';
export const SERVER_FIELDS = gql `
  fragment ServerFields on Server {
    id
    clientId
    createdAt
    updatedAt
    name
    hostname
    port
    username
  }
`;
export const SERVERS = gql `
  ${SERVER_FIELDS}
  query SERVERS($spec: ServerSpec!) {
    servers(spec: $spec) {
      ...ServerFields
    }
  }
`;
export const TEST_SERVER = gql `
  query TEST_SERVER($input: ServerInput!) {
    testServer(input: $input)
  }
`;
export const SAVE_SERVER = gql `
  ${SERVER_FIELDS}
  mutation SAVE_SERVER($input: ServerInput!) {
    saveServer(input: $input) {
      ...ServerFields
    }
  }
`;
export const DELETE_SERVER = gql `
  mutation DELETE_SERVER($id: Int!) {
    deleteServer(id: $id) {
      id
      name
    }
  }
`;
